import { render } from "./StatusHistoryModal.vue?vue&type=template&id=3038963a"
import script from "./StatusHistoryModal.vue?vue&type=script&lang=js"
export * from "./StatusHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__